import React from 'react';
import MapContainer from '../../../components/cognien-components/Google-Map/MapContainer';
import LeftpaneComponent from '../../../components/cognien-components/Leftpane/left-pane';

const LoadMap = () => {
    return (
        <div>
            <LeftpaneComponent />
            <MapContainer />
        </div>
    );
}
export default LoadMap;

